<template>
  <v-container>
    <v-data-table :headers="headers" :items="listItems" class="elevation-0">
      <template v-slot:top>
        <v-toolbar flat color="white" v-if="ShowDialogName">
          <!-- <v-card-subtitle class="settings-header-text">{{
            listType.name
          }}</v-card-subtitle> -->
          <v-spacer v-if="$vuetify.breakpoint.mdAndUp"></v-spacer>
          <div v-if="listType.code != 'call_tracking_number'">
            <v-dialog v-model="dialog" max-width="500px">
              <template v-slot:activator="{ on }">
                <v-btn
                  color="primary"
                  @click="onDialogOpen"
                  dark
                  class="mb-2"
                  v-on="on"
                  >New {{ listType.name }}</v-btn
                >
              </template>

              <list-type-field-editor
                v-if="dialog"
                :listTypeId="listType.id"
                :listType="listType"
                :item="editedItem"
                :onSave="onSave"
                :onClose="onClose"
              ></list-type-field-editor>
            </v-dialog>
          </div>
        </v-toolbar>
      </template>

      <template v-slot:item.rank="{ item }">
        <v-icon small class="mr-2" @click="onArrowUp(item)">
          mdi-arrow-up-bold
        </v-icon>
        <v-icon small @click="onArrowDown(item)">
          mdi-arrow-down-bold
        </v-icon>
      </template>

      <template v-slot:item.name="{ item }">
        <div class="clickable" @click="onEditItem(item)">
          {{ item.name }}
        </div>
      </template>

      <template v-slot:item.value="{ item }">
        <div class="clickable" @click="onEditItem(item)">
          {{ item.meta.value }}
        </div>
      </template>

      <template v-slot:item.meta.value.display="{ item }">
        <div class="clickable" @click="onEditItem(item)">
          {{ item.meta.value.display }}
        </div>
      </template>

      <template v-slot:item.meta.value.flowId="{ item }">
        <div
          class="clickable"
          @click="onEditItem(item)"
          v-if="item.meta.value.flowId"
        >
          {{ getCallFlowName(item) }}
        </div>
        <div class="clickable" @click="onEditItem(item)" v-else>
          <v-btn text small color="error"
            ><v-icon class="mr-2" small>mdi-alert-circle</v-icon> Set Call
            Flow</v-btn
          >
        </div>
      </template>

      <template v-slot:item.meta.value.sourceId="{ item }">
        <div class="clickable" @click="onEditItem(item)">
          {{ getLeadSourceName(item) }}
        </div>
      </template>

      <template v-slot:item.colorOnly="{ item }">
        <div class="v-color-picker__color" @click="onEditItem(item)">
          <div :style="{ background: item.meta.color }"></div>
        </div>
      </template>

      <template v-slot:item.actions="{ item }">
        <v-icon small class="mr-2" @click="onEditItem(item)">
          mdi-pencil
        </v-icon>
        <v-icon small @click="onDeleteItem(item)" v-if="notCallTrackingItem()">
          mdi-delete
        </v-icon>
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
import ListItem from "../../../models/ListItem";
// import ListTypeFieldEditor from "./ListTypeFieldEditor";
import { REPLACE_WITH_REVIEW_LINK } from "../../../globalVars";
const ListTypeFieldEditor = () =>
  import(
    /* webpackChunkName: "components-settings-ListTypeFieldEditor" */ `./ListTypeFieldEditor`
  );
// const MessageContentBubble = () =>
//   import(
//     /* webpackChunkName: "components-customers-history-MessageContentBubble" */ `../../customers/history/MessageContentBubble.vue`
//   );
import { VALIDATION_RULES } from "../../../helpers/ValidationRules";
import Message from "../../../models/Message";
import { MASKS } from "../../../helpers/Masks";
import { mask } from "vue-the-mask";

export default {
  name: "ListTypeFieldSettings",
  components: {
    // MessageContentBubble,
    ListTypeFieldEditor
  },
  directives: {
    mask
  },
  props: {
    ShowDialogName: {
      type: Boolean,
      default: true,
      required: false
    },
    EditItemFunction: {
      type: Function,
      required: false
    },
    listTypeId: {
      type: Number,
      required: true
    },
    Headers: {
      type: Array,
      required: false
    }
  },
  data: function() {
    return {
      REPLACE_WITH_REVIEW_LINK: REPLACE_WITH_REVIEW_LINK,
      dialog: false,
      formValid: true,
      editedIndex: -1,
      editedItem: new ListItem(),

      masks: MASKS,
      rules: VALIDATION_RULES
    };
  },
  created() {},
  computed: {
    headers() {
      let headers = [
        { text: "Order", value: "rank", sortable: false },
        {
          text: "Name",
          align: "start",
          value: "name",
          sortable: false
        }
      ];
      if (this.Headers) {
        headers = this.Headers;
      }
      if (["job_type"].includes(this.listType.code)) {
        headers.push({ text: "Color", value: "colorOnly", sortable: false });
      }
      if (["msg_template"].includes(this.listType.code)) {
        headers.push({ text: "Value", value: "value", sortable: false });
      }
      if (
        headers.length > 0 &&
        headers[headers.length - 1].value != "actions"
      ) {
        headers.push({ text: "Action", value: "actions", sortable: false });
      }
      return headers;
    },
    formTitle() {
      return this.editedIndex === -1 ? "Add" : "Edit";
    },
    listType() {
      let listType = this.$store.getters["entities/listTypes/query"]()
        .where("id", this.listTypeId)
        .first();
      return listType;
    },
    listItems() {
      let listItems = this.$store.getters["entities/listItems/query"]()
        .where("listTypeId", this.listTypeId)
        .orderBy("rank")
        .get();
      return listItems;
    },
    testReviewRequestMessage() {
      let testMessage = new Message();
      testMessage.isInbound = false;
      testMessage.user = this.user;
      testMessage.createdAt = new Date();
      testMessage.updatedAt = new Date();
      testMessage.messageBody = this.editedItem.meta.value;
      return testMessage;
    }
  },
  methods: {
    getCallFlowName(item) {
      if (item && item.meta && item.meta.value && item.meta.value.flowId) {
        let itemVal = this.$store.getters["entities/listItems/query"]()
          .where("id", item.meta.value.flowId)
          .first();
        return itemVal.name;
      }
      return "     ";
    },
    getLeadSourceName(item) {
      if (item && item.meta && item.meta.value && item.meta.value.sourceId) {
        let itemVal = this.$store.getters["entities/listItems/query"]()
          .where("id", item.meta.value.sourceId)
          .first();
        return itemVal.name;
      }
      return "     ";
    },
    notCallTrackingItem() {
      return this.listType.code == "call_tracking_number" ? false : true;
    },
    changeEditedItemColor(color) {
      if (typeof color == "object" && color.hexa) {
        this.editedItem.meta.color = color.hexa.substring(0, 7);
      } else {
        this.editedItem.meta.color = color.substring(0, 7);
      }
    },
    onArrowUp(item) {
      if (item.rank === 0) {
        return;
      }
      let listItems = [...this.listItems];
      if (item.rank) {
        listItems.splice(item.rank - 1, 0, listItems.splice(item.rank, 1)[0]);
      }
      for (let i = 0; i < listItems.length; i++) {
        let tempItem = listItems[i];
        tempItem.rank = i;
        this.$store.dispatch("entities/listItems/updateListItem", tempItem);
      }
    },
    onArrowDown(item) {
      if (item.rank && item.rank >= this.listItems.length - 1) {
        return;
      }
      let newItemTypes = [...this.listItems];
      if (item.rank >= 0) {
        newItemTypes.splice(
          item.rank + 1,
          0,
          newItemTypes.splice(item.rank, 1)[0]
        );
      }
      for (let i = 0; i < newItemTypes.length; i++) {
        let tempItem = newItemTypes[i];
        tempItem.rank = i;
        this.$store.dispatch("entities/listItems/updateListItem", tempItem);
      }
    },
    onEditItem(item) {
      if (typeof this.EditItemFunction == "function") {
        this.EditItemFunction(item);
      } else {
        if (this.$refs && this.$refs.form) {
          this.$refs.form.resetValidation();
        }
        this.editedIndex = this.listItems.indexOf(item);
        this.editedItem = Object.assign({}, item);
        this.dialog = true;
      }
    },
    onDeleteItem(item) {
      if (confirm("Are you sure you want to delete this item?")) {
        item.isDirty = true;
        this.$store.dispatch("entities/listItems/deleteListItem", item);
      }
    },
    onDialogOpen() {
      if (this.$refs && this.$refs.form) {
        this.$refs.form.resetValidation();
      }
    },
    onClose() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, new ListItem());
        this.editedIndex = -1;
      }, 300);
    },
    onSave() {
      let vueThis = this;
      // Add New
      if (!(this.editedItem && this.editedItem.id)) {
        this.editedItem.isDirty = true;
        this.editedItem.listTypeId = this.listTypeId;
        this.editedItem.rank = this.listItems.length;
        vueThis.$store.dispatch(
          "entities/listItems/createListItem",
          vueThis.editedItem
        );
        // Edit
      } else if (this.editedItem) {
        vueThis.editedItem.isDirty = true;
        vueThis.$store.dispatch(
          "entities/listItems/updateListItem",
          vueThis.editedItem
        );
      }
      this.onClose();
    }
  },
  watch: {
    dialog(val) {
      val || this.onClose();
    }
  }
};
</script>

<style scoped lang="stylus">
div.spacer {
  width: 3rem;
}
div.sample-color {
  width: 90%;
  max-height: 2rem !important;
  height: 2rem !important;
}
div.v-menu__content {
  background-color: white;
}
</style>
